const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 989px)" ) ];
class Blocks {
  constructor () {
    this.init();
  }
  init () {
    this.opening();
    this.headScroll();
    this.concept();
  }

  opening() {
    const Mv = d.querySelector('.mainvisual');
    w.addEventListener('load', function(){
      Mv.classList.add('loaded');
    });
  }

  headScroll () {
    if( mq.matches ) {
      $(w).on('load scroll', function(){
        let scroll = $(this).scrollTop();
        if ( scroll >= 100) {
          $('header').addClass('scroll');
        } else {
          $('header').removeClass('scroll');
        }
      });
    } else {
      $(w).on('load scroll', function(){
        let scroll = $(this).scrollTop();
        let mvH = $('.mainvisual').height();
        if ( scroll >= mvH) {
          $('header').addClass('scroll');
        } else {
          $('header').removeClass('scroll');
        }
      });
    }
  }

  concept () {
    let par1 = $(".scroll_parts1");
    let par2 = $(".scroll_parts2");
    let windowH = $(window).height();
    let animStart = $('.block-concept').offset().top - 100;
    $(w).on('scroll',function(){
      let scroll = $(this).scrollTop();
      let scrollH = scroll + windowH;
      if(scrollH > animStart){
        $('.bg_shape').addClass('active');
        par1.css('transform', 'translateY(' + (scrollH - animStart) * 0.05 + 'px)');
        par2.css('transform', 'translateY(' + (scrollH - animStart) * 0.02 + 'px)');
      }
    });
  }
}

const init = () => {
  new Blocks;
};

export default function HOME () {
  $(init)
}